import React from 'react';
import ReactDOM from 'react-dom';
import { store } from 'src/app/store';
import { Provider } from 'react-redux';
import AACChromeAPI from '@amzn/aac-chrome-api';
import { markComponentStart } from 'src/commons/utils/logWithTakt';
import { CHROME_APP_NAME, Components } from 'src/commons/constants';
import { performanceMark } from 'src/utils/performance-helper';
import { InternalChromeConfigContextProvider } from 'src/providers/InternalChromeConfigContextProvider';
import { ChromeConfigContextProvider } from 'src/providers/ChromeConfigContextProvider';
import { ConnectedChromeApp } from 'src/commons/components/ChromeApp/ChromeApp';
import { PageHeaderBundleProvider } from 'src/providers/PantherLocalizationProvider';
import { isFromBtswWc, isFromTrim } from 'src/commons/utils';
import { PageHeader, updatePageHeader } from 'src/app/slice';
import { toPlainData } from 'src/commons/utils/toPlainData';
import { ErrorIdProvider } from '@amzn/storm-ui';
import { ConnectedPageHeader } from 'src/features/header/components/PageHeader/PageHeader';

const PAGE_HEADER_CONFIG = 'initChromePageHeaderConfig';
export default class AXChromePageHeader extends HTMLElement {
  static observedAttributes = [PAGE_HEADER_CONFIG];

  set initChromePageHeaderConfig(initChromePageHeaderConfig: PageHeader) {
    if (
      initChromePageHeaderConfig &&
      Object.keys(initChromePageHeaderConfig).length > 0
    ) {
      this.updateStoreAndChromeAPI(initChromePageHeaderConfig);
    }
  }

  updateStoreAndChromeAPI(initChromePageHeaderConfig: PageHeader) {
    store.dispatch(
      updatePageHeader(toPlainData<PageHeader>(initChromePageHeaderConfig)),
    );
    const chromeConfig = AACChromeAPI.getChromeConfiguration();
    chromeConfig.setPageHeader(initChromePageHeaderConfig);
    AACChromeAPI.setChromeConfiguration(chromeConfig);
  }

  async _renderPageHeader() {
    if (!isFromTrim() && !isFromBtswWc()) return;
    markComponentStart(Components.PAGE_HEADER);
    const endMarker = performanceMark('aac-chrome-ui-page-header');

    ReactDOM.render(
      <ErrorIdProvider id="Chrome">
        <Provider store={store}>
          <InternalChromeConfigContextProvider>
            <ChromeConfigContextProvider>
              <ConnectedChromeApp name={CHROME_APP_NAME.PageHeader}>
                <PageHeaderBundleProvider>
                  <ConnectedPageHeader />
                </PageHeaderBundleProvider>
              </ConnectedChromeApp>
            </ChromeConfigContextProvider>
          </InternalChromeConfigContextProvider>
        </Provider>
      </ErrorIdProvider>,
      this,
    );

    endMarker();
  }

  connectedCallback(): void {
    this._renderPageHeader();
  }
}

if (!customElements.get('ax-chrome-page-header')) {
  customElements.define('ax-chrome-page-header', AXChromePageHeader);
}
